import { showErrorToast } from '@amigoapp/doca-react';
import { createLocalVideoTrack } from 'livekit-client';
import { useEffect, useRef, useState } from 'react';

const PREVIEW_VIDEO = {
	width: { ideal: 960 },
	height: { ideal: 540 }
};

const usePreviewMedia = ({ videoDeviceId }) => {
	const [videoTrack, setVideoTrack] = useState(null);

	const [status, setStatus] = useState('pending');

	const initialDeviceId = useRef(videoDeviceId).current;

	const handedOffRef = useRef(false);

	useEffect(() => {
		let cancelled = false;
		let started = null;

		const start = async () => {
			try {
				const camera = await createLocalVideoTrack({
					...PREVIEW_VIDEO,
					...(initialDeviceId ? { deviceId: { ideal: initialDeviceId } } : {})
				});

				if (cancelled && !handedOffRef.current) {
					camera.stop();

					return;
				}

				started = camera;

				if (!cancelled) {
					setVideoTrack(camera);
					setStatus('ready');
				}
			} catch (error) {
				if (!cancelled) {
					setStatus('failed');
					showErrorToast('Não foi possível acessar a câmera.');
				}
			}
		};

		start();

		return () => {
			cancelled = true;

			// eslint-disable-next-line react-hooks/exhaustive-deps
			if (!handedOffRef.current) {
				started?.stop();
			}
		};
	}, [initialDeviceId]);

	return { videoTrack, handedOffRef, status };
};

export default usePreviewMedia;
